import Vuex, { Store } from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';
import send from './send/index';
import login from './login/index';
import app from './app/index';
import register from './register/index';
import calculate from './calculate/index';
import order from './order/index';
import home from './home/index';
import views from './user/index';
import appVersion from '@/version';

const createVersionedPlugin = (baseKey, paths) => {
  return createPersistedState({
    storage: window.localStorage,
    key: `${baseKey}-${appVersion}`,
    paths,
    beforeRestore: (store) => {
      cleanupOldVersions(baseKey);
    },
  });
};

const cleanupOldVersions = baseKey => {
  const currentKey = `${baseKey}-${appVersion}`;

  // 遍历 localStorage 查找旧版本缓存
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(baseKey + '-') && key !== currentKey) {
      console.log(`[缓存清理] 检测到旧版本缓存: ${key}`);
      localStorage.removeItem(key);
    }
  });

  if (localStorage.getItem(baseKey)) {
    console.log(`[缓存清理] 检测到无版本缓存: ${baseKey}`);
    localStorage.removeItem(baseKey);
  }
};

// 创建带版本控制的插件
const dataState = createVersionedPlugin('_moving-kite', ['calculate']);
const dataHomeState = createVersionedPlugin('_home-state', ['home']);



Vue.use(Vuex);

const store = new Store({
  modules: {
    send,
    login,
    app,
    register,
    calculate,
    order,
    home,
    views,
  },
  plugins: [dataState, dataHomeState],
  getters: {
    app: () => {
      return app.state;
    },
  },
});

export default store;
